import type { FC } from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { MultilineTeaserField } from '@/features/profile-setting/components/organization-edit/MultilineTeaserField';
import { makeOrganizationEditFormStyles } from '@/features/profile-setting/components/organization-edit/organizationEditFormStyles';
import type { ExtensionSectionProps } from '@/features/profile-setting/components/organization-extensions/types';
import { MAYOR_GREETING_MAX_LENGTH } from '@/features/profile-setting/constants/organization';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';
import { useAppTheme } from '@/styles/hooks/useAppTheme';

export const TerritorialAuthorityCreateSection: FC<ExtensionSectionProps> = ({
  namePrefix,
  disabled
}) => {
  const { t } = useTranslation(LocalizationNameSpace.PROFILE_SETTING, {
    keyPrefix: 'screens.organization-create'
  });
  const theme = useAppTheme();
  const styles = useMemo(() => makeOrganizationEditFormStyles(theme), [theme]);
  const name = `${namePrefix}.mayorGreeting` as const;

  return (
    <MultilineTeaserField
      name={name}
      sectionTitle={t('fields.mayorGreeting')}
      placeholder={t('placeholders.mayorGreeting')}
      editorTitle={t('fields.mayorGreeting')}
      editorPlaceholder={t('placeholders.mayorGreeting')}
      maxLength={MAYOR_GREETING_MAX_LENGTH}
      isPending={disabled ?? false}
      styles={styles}
    />
  );
};
